import {Component, Inject, Input, LOCALE_ID, OnInit, Renderer2, ViewChild} from '@angular/core';
import {Menubar, MenubarModule} from "primeng/menubar";
import {MenuItem, MenuItemCommandEvent, TreeNode} from "primeng/api";
import {AccordionModule} from "primeng/accordion";
import {ButtonModule} from "primeng/button";
import {TemplateComponent} from "../../template/template.component";
import {Router} from "@angular/router";
import {GlobalService} from "../../../services/global.service";
import {NgForOf, NgIf} from "@angular/common";
import {locale} from "moment";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {config} from "rxjs";
import {Config, ConfigService} from "../../../services/config.service";

@Component({
    selector: 'app-menu-bar',
    standalone: true,
    imports: [
        MenubarModule,
        AccordionModule,
        ButtonModule,
        NgIf,
        NgForOf,
        ReactiveFormsModule,
        FormsModule
    ],
    templateUrl: './menu-bar.component.html',
    styleUrl: './menu-bar.component.css'
})
export class MenuBarComponent implements OnInit {
    @Input() items: MenuItem[] | undefined;
    @Input() topItems: MenuItem[] | undefined;
    @Input() perform: any;
    @Input() dashboardLink: string;
    pathName: string = "";
    language: string = "fa";


    @ViewChild("maimenu") maimenu: Menubar;

    constructor(public route: Router,
                @Inject(LOCALE_ID) public locale: string,
                public global: GlobalService,
                private renderer: Renderer2,
                public conf: ConfigService) {

    }

    ngOnInit(): void {
        this.pathName = location.pathname;
        setTimeout(() => {
            this.renderer.listen(this.maimenu.el.nativeElement, 'mouseleave', () => {
                this.maimenu.hide();
            });
        }, 500)

    }


    menuTaggel(sidMnu: HTMLDivElement) {
        sidMnu.hidden = !sidMnu.hidden;
    }

    goToHome() {
        this.route.navigate(["/"]);
        setTimeout(() => {
            this.pathName = location.pathname;
        }, 100)

    }


    menuClick() {
        // if (this.pathName != location.pathname)
        // this.route.navigateByUrl("/");
        // location.reload();
    }

    goToDashboardLogin() {
        window.open(this.dashboardLink['loginUrl']);
    }

    goToItem(rootItem: MenuItem) {
        if (rootItem.url != null && rootItem.url.length > 4) {
            window.open(rootItem.url);
        } else {
            rootItem.command({});
        }


    }

    clickRootMenu(rootItem: MenuItem, sidMnu) {
        if (rootItem.items.length < 1) {
            this.goToItem(rootItem);
            this.menuTaggel(sidMnu)
        }
    }

    changLanguageTop() {

        let loc = window.location.pathname.split('/')[1];
        this.goToHome();
        setTimeout(() => {
            if (loc.length > 1)
                window.location.href = window.location.href.replace("/" + loc + "/", "/" + this.language + "/");

        }, 100);



    }

    protected readonly config = config;
}
